import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-w-small', 'IconLetterWSmall', [["path",{"d":"M9 8l1 8l2 -5l2 5l1 -8","key":"svg-0"}]]);